import { ROUTE_PATHS } from '../constants/routePaths';

export const goToHomePage = () => {
    return window.location.assign(ROUTE_PATHS.marketplace());
};
